import { createAsyncThunk } from '@reduxjs/toolkit';
import focusSkuApi from '../../../../services/apiService/api/focusSkuApi'

export const getFocusSkuHistoryThunk = createAsyncThunk(
  'focusSku/getFocusSkuHistory',
  async ({ page = 0, pageSize = 20 }, { rejectWithValue }) => {
    try {
      const response = await focusSkuApi.fetchFocusSkuHistory({ page, pageSize });
      response.data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
); 